export default { // 该需求运行在销售app，入口 车源 -> 私海车源 -> 车源详情的左下角3个点 -> 私有保护期设置。评估师app入口 我得工单-更多-新增“私有保护期设置
  tabs: [
    {
      name: 'ProtectedConfig',
      path: '/protectedConfig',
      component: () => import('./src/ProtectedConfig.vue'),
      meta: {
        title: '私有保护期设置',
        isMenu: true,
      }
    }
  ]
}
